export const EProgramStatus = {
  CONFIGURATION: 'CONFIGURATION',
  CONFIGURATION_COMPLETED: 'CONFIGURATION_COMPLETED',
  IN_PROGRESS: 'IN_PROGRESS',
  CLOSING: 'CLOSING',
  COMPLETED: 'COMPLETED',
  EXCLUDED: 'EXCLUDED',
  BLOCKED: 'BLOCKED'
} as const;

export type EProgramStatus =
  (typeof EProgramStatus)[keyof typeof EProgramStatus];
